<template>
    <div class="results-box">
        <h1>Breadth</h1>
        <medal :medalType="label" />
        <p>Do you seek information from the same people, websites, and internal company sources on a regular basis? Many leaders do this and the reasons are often lack of time, lack of awareness and unintentional data gathering (seeing what is easily found, rather than looking for additional perspective). Consider the possibilities of expanding the way you scan by thinking more broadly about your questions, looking for new and even unconventional sources of information and watching the trends in the broader environment.</p>
        <p>Here’s how you did:</p>
        <p v-html="desc"></p>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex"
    import Medal from '@/components/Medal.vue'
    
    export default{
        name : "BreadthRibbonFeedback",
        components: {
            'medal' : Medal,
        },
        data(){
            return {
                rbn : "",
                desc : "",
                overview : "",
                label: ""
            }
        },
        mounted(){
            this.setRibbon()
            // TODO: add text to JSON
        },
        computed : {
            ...mapGetters([
                "playerTotal",
                "getScoring",
                "getBreadthResult"
            ])
        },
        methods : {
            setRibbon(){
                const cat     = this.getBreadthResult
                const content = this.getScoring.breadth.options[ cat ]
                this.rbn   = content.source
                this.label = content.label
                this.desc  = content.description
            }
        }
    }
</script>